import { MenuItem, Tooltip, Typography, MenuItemProps } from '@mui/material';
import { MapAttribute } from '../../models/map-attribute';
import { useHasAccess } from '../../payWall/RevenueCatProvider';
import PaidIcon from '@mui/icons-material/Paid';
import { Link } from 'react-admin';
import { PaidFeatureIcon } from '../pay-wall/PaidFeatureIcon';
import { MembershipType } from '../../payWall/paywall.model';


export const mapAttributeItem = (mapAttribute: MapAttribute) => (
  <Tooltip title={mapAttribute.description} placement='right-start'>
    <Typography variant='inherit'>
      {mapAttribute.name}
    </Typography>
  </Tooltip>
);

const membershipFromAttributeCategoryMap: Record<string, MembershipType> = {
  'Basic': 'Free',
  'Advanced': 'Novice',
  'Expert': 'Pro'
};

type MapAttributeMenuItemProps = MenuItemProps & { mapAttribute: MapAttribute };

export const MapAttributeMenuItem = ({
  mapAttribute,
  ...props
}: MapAttributeMenuItemProps) => {
  const [hasNoviceAccess] = useHasAccess('Novice');
  const [hasProAccess] = useHasAccess('Pro');

  const isAvailable =
    mapAttribute.category === 'Basic' ||
    (mapAttribute.category === 'Advanced' && hasNoviceAccess) ||
    (mapAttribute.category === 'Expert' && hasProAccess);

  if (!isAvailable) {
    return (
      <MenuItem href component={Link} to='/pricing'>
        <PaidFeatureIcon membership={membershipFromAttributeCategoryMap[mapAttribute.category]} />
        {mapAttributeItem(mapAttribute)}
      </MenuItem>
    );
  }

  return (
    <MenuItem {...props}>{mapAttributeItem(mapAttribute)}</MenuItem>
  );
};


